export type ProcoreUserCompaniesResponsePayload = Array<{
  id: number
  isActive?: boolean
  name: string
}>

export type ProcoreCompanyRequestPayload = {
  companyId: number
}

export type ProcoreProjectRequestPayload = {
  companyId: number
  projectId: number
}

export type ProcoreObservationListItem = {
  id: number
  name: string
}

export type ProcoreObservationDefaultList = Array<
  ProcoreObservationListItem & {
    active: boolean
    global: boolean
    createdAt: string
    updatedAt: string
  }
>

export type ProcoreObservationAssignee = ProcoreObservationListItem & {
  vendor: ProcoreObservationListItem
}

export type ProcoreObservationDistributionMember =
  ProcoreObservationListItem & {
    login: string
  }

export type ProcoreObservationTrades = ProcoreObservationListItem & {
  active: boolean
  updatedAt: string
}

export type ProcoreObservationLocation = ProcoreObservationListItem & {
  nodeName: string
  parentId: number
  createdAt: string
  updatedAt: string
  code: string
}

export type ProcoreObservationSpecificationSection = {
  id: number
  number: string
  description: string
  label: string
  currentRevisionId: number
}

export type ProcoreUserProjectsResponsePayload = Array<{
  accountingProjectNumber?: number
  active: boolean
  address: string
  city: string
  company: {
    id: number
    name: string
  }
  completionDate: string
  countryCode: string
  county: string
  createdAt: string
  customFields?: object
  designatedMarketArea: string
  displayName: string
  estimatedValue: string
  id: number
  isDemo: boolean
  latitude: number
  longitude: number
  name: string
  originCode: string | number | null
  originData: string | null
  originId: number | null
  ownersProjectId: number | null
  parentJobId: number | null
  phone: string | number
  photoId: number
  projectBidTypeId: number | null
  projectNumber: string
  projectOwnerTypeId: number | null
  projectRegionId: number | null
  stage: string
  startDate: string
  stateCode: string
  storeNumber?: string
  timeZone: string
  totalValue: string
  updatedAt: string
  zip: number
}>

export type ProcoreEditedImageUploadRequestPayload = {
  projectExid: string
  companyId: number
  projectId: number
  snapshot: string
  categoryId?: number
}

export type ProcoreProjectsAlbumsPayload = Array<{
  count: number
  coverPhoto: string | null
  createdAt: string
  id: number
  links: {
    delete: string
    show: string
    update: string
  }
  name: string
  position: number
  private: boolean
  updatedAt: string
}>

export type ProcoreObservationTypesResponsePayload = Array<{
  id: number
  name: string
  localizedName: string
  category: string
  categoryKey: string
  companyActive: boolean
  active: boolean
  kind: string
  parentInactive: boolean
  isUse: boolean
  nameTranslations: string
}>

export type ProcoreObservationFormRequestPayload = {
  projectId: number
  companyId: number
  observationType: string
}

export type ProcoreObservationForm = Record<
  string,
  ProcoreObservationField | ProcoreObservationCustomField
>

export type ProcoreObservationField = {
  name: string
  required: boolean
  visible: boolean
}

export type ProcoreObservationCustomField = {
  id: number
  required: boolean
  visible: boolean
  name: string
  label: string
  description: string
  customFieldDefinitionId: number
  dataType: ProcoreObservationCustomFieldDataType
  variant: string
  position: number
  row: number
  column: number
  columnWidth: number
  optionsUrl: string | null
  defaultValue: string | null
}

export enum ProcoreObservationCustomFieldDataType {
  RichText = "rich_text",
  Date = "date",
  DateTime = "datetime",
  LovEnty = "lov_entry",
  LovEntries = "lov_entries",
  Boolean = "boolean",
  Vendor = "vendor",
  Decimal = "decimal",
  String = "string",
  LoginInformation = "login_information",
  LoginInformations = "login_informations",
  Dropdown = "dropdown",
}

export enum ProcoreObservationDefaultFieldNames {
  Number = "number",
  Name = "name",
  Status = "status",
  Trade = "trade_id",
  Assignee = "assignee_id",
  DueDate = "due_date",
  SpecificationSection = "specification_section_id",
  Priority = "priority",
  Location = "location_id",
  DistributionMembers = "distribution_member_ids",
  Personal = "personal",
  Hazard = "hazard_id",
  ContributingBehavior = "contributing_behavior_id",
  ContributingCondition = "contributing_condition_id",
  Description = "description",
}
